import React from "react";
import { OpenCloseHookProps } from "../../utils/hooks/OpenCloseHook";
import { TransitionProps } from "@material-ui/core/transitions";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";

interface dialogProps {
    openHook: OpenCloseHookProps;
    content: any;
    title: any;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export const FullScreenDialog: React.FC<dialogProps> = ({openHook, content, title}) => {
    return <Dialog
        fullScreen
        open={openHook.isOpen}
        onClose={() => openHook.close()}
        // @ts-ignore
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar className="port-details-toolbar space-between">
            <h1>{title}</h1>
            <IconButton edge="end" color="inherit" onClick={() => openHook.close()} aria-label="close">
              X
            </IconButton>
          </Toolbar>
        </AppBar>
        {content}
      </Dialog>
}